
import { ManagementTemplate } from 'components/templates'

const Management = (): JSX.Element => {
  return <ManagementTemplate />
}

export default Management
